const { REACT_APP_PING_LOGIN_HOST } = process.env;
export const apiConfig = {
  pingAuthUrl: `${REACT_APP_PING_LOGIN_HOST}/as/authorization.oauth2`,
  pingTokenUrl: `${REACT_APP_PING_LOGIN_HOST}/as/token.oauth2`,
  redirectUrl: `${window.location.origin}/login`,
};
